import { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import 'animate.css';
import config from "../Config";
import { useAtom } from 'jotai'
import axios from "axios";
import { authUserAtom } from '../Services/store/atoms';

const sizeClasses = {
  sm: {
    input: 'p-2.5 text-xs', button: 'p-1.5 right-1', icon: 'w-4 h-4',
    dropdownBtn: 'py-1.5 px-2.5 text-xs', dropdown: 'mt-8 w-36',
    leftPad: 'pl-8', leftPadCat: 'pl-36',
  },
  md: {
    input: 'p-4 text-sm', button: 'p-2 right-1', icon: 'w-5 h-5',
    dropdownBtn: 'py-3 px-4 text-sm', dropdown: 'mt-11 w-44',
    leftPad: 'pl-10', leftPadCat: 'pl-44',
  },
  lg: {
    input: 'p-5 text-base', button: 'p-2.5 right-1', icon: 'w-6 h-6',
    dropdownBtn: 'py-4 px-5 text-base', dropdown: 'mt-13 w-52',
    leftPad: 'pl-12', leftPadCat: 'pl-52',
  },
};

function InputSearch(props) {
    const dropdownRef = useRef(null);
    const [authUser] = useAtom(authUserAtom)
    const [show, setShow] = useState('hidden')
    const [selectOption, setSelectOption] = useState({ label: "All Categories", value: "all" })
    const [categories, setCategories] = useState([]);

    const {
      hideCategories = false,
      size = 'md',
      darkMode = false,
      onKeyDown,
      placeholder = 'Search...',
      showSubmitButton = true,
      value,
    } = props;
    const s = sizeClasses[size];

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                axios.defaults.headers.common.Authorization = `Bearer ${authUser.token}`;
                const response = await axios.get(`${config.REACT_APP_BASE_URL}/api/v1/packs/categoriesSelect`);
                setCategories(response.data);
            } catch (error) {
                console.error("Error fetching categories: ", error);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow('hidden');
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    const showOptions = () => {
        if (show == 'hidden') {
            setShow('')
        }
        else {
            setShow('hidden')
        }
    }

    const selectOptionHandler = (option) => {
        setSelectOption(option)
        setShow('hidden')
        props.handlerCategories?.(option.value)
    }

    const handleSearchInputChange = (event) => {
        props.handlerSearch?.(event.target.value)
    };

    const handlerSend = () => {
        props.send?.()
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onKeyDown?.(e);
      }
    };

    return (
        <div className="flex justify-center w-full">
            <div className="relative w-full">
                {!hideCategories && (
                    <div>
                        <button onClick={() => showOptions()} id="dropdown-button" data-dropdown-toggle="dropdown"
                            className={`absolute m-1 rounded-full flex-shrink-0 z-10 inline-flex items-center ${s.dropdownBtn} font-medium text-center text-gray-900 bg-gray-100 border border-gray-200 hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-400`} type="button">
                            {selectOption.label}
                            <svg className="w-2.5 h-2.5 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                            </svg></button>

                        <div ref={dropdownRef} id="dropdown" className={`z-10 absolute mt-11 bg-white divide-y divide-gray-100 rounded-xl shadow ${s.dropdown} dark:bg-gray-700 ${show}`} >
                            <ul className="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdown-button">
                                {categories.map((category, index) => (
                                    <li key={index}>
                                        <button onClick={() => selectOptionHandler({ label: category, value: category })} type="button" className="inline-flex w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">{category}</button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
                <div className="relative">
                    {hideCategories && (
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <svg aria-hidden="true" className={`${s.icon} text-gray-500 dark:text-gray-400`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                          </svg>
                      </div>
                    )}
                    <input
                      type="search"
                      id="search-dropdown"
                      value={value}
                      onChange={handleSearchInputChange}
                      onKeyDown={handleKeyDown}
                      className={`block w-full ${s.input} ${hideCategories ? s.leftPad : s.leftPadCat} rounded-full border ${
                        darkMode
                          ? 'bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-rose-500 focus:border-rose-500'
                          : 'bg-gray-50 border-gray-200 text-gray-900 focus:ring-rose-500 focus:border-rose-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-rose-500 dark:focus:border-rose-500'
                      } font-semibold`}
                      placeholder={placeholder}
                      required
                    />
                    {showSubmitButton && (
                      <button onClick={() => handlerSend()} type="submit" className={`absolute top-0 mt-1 ${s.button} text-sm font-medium text-white bg-red-700 rounded-full border border-red-700 hover:bg-rose-600 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-rose-500 dark:hover:bg-red-700 dark:focus:ring-red-800 transition ease-in-out delay-20 hover:scale-110 hover:border-rose-400 duration-300`}>
                          <svg className={s.icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                          </svg>
                          <span className="sr-only">Search</span>
                      </button>
                    )}
                </div>
            </div>
        </div>
    );
}

InputSearch.propTypes = {
  hideCategories: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  darkMode: PropTypes.bool,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  showSubmitButton: PropTypes.bool,
  handlerCategories: PropTypes.func,
  handlerSearch: PropTypes.func,
  send: PropTypes.func,
  value: PropTypes.string,
};

export default InputSearch;
